import { useMemo, useContext } from 'react';

import { SYSTEM_HEADER_LEFT } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { useWebItemLocation } from '@confluence/web-item-location/entry-points/useWebItemLocation.ts';
import { useIsCompanyHubEnabled } from '@confluence/company-hub-utils/entry-points/useIsCompanyHubEnabled.ts';
import { SPAViewContext } from '@confluence/spa-view-context/entry-points/SPAViewContext.ts';
import { useViewUserProfile } from '@confluence/global-operations/entry-points/useViewUserProfile.ts';

// eslint-disable-next-line import/no-cycle
import { PEOPLE_DIRECTORY_KEY, SPACE_DIRECTORY_KEY } from '../../useMenuItems.ts';

export const useShortcutVisibilityOverrides = () => {
	const { loading: webItemsLoading, webItems } = useWebItemLocation({
		location: SYSTEM_HEADER_LEFT,
		allowedWebItems: [SPACE_DIRECTORY_KEY, PEOPLE_DIRECTORY_KEY],
	});
	const { isCompanyHubEntryPointEnabled } = useIsCompanyHubEnabled();
	const { frontCoverState, loading } = useContext(SPAViewContext);
	const { canViewUserProfile: hasViewUserProfilePermission } = useViewUserProfile();

	const isPeopleVisible =
		!webItemsLoading &&
		(hasViewUserProfilePermission ||
			!!webItems.find((item) => item.completeKey === PEOPLE_DIRECTORY_KEY));
	const isCompanyHubVisible = !loading && isCompanyHubEntryPointEnabled && !!frontCoverState;

	return useMemo(
		() => ({
			isPeopleVisible,
			isCompanyHubVisible,
		}),
		[isCompanyHubVisible, isPeopleVisible],
	);
};
